import React, { useState, useEffect, useRef } from 'react';
import { emailSignupService } from '../lib/supabase';

function EmailSignup({ isWaitlistOnly = false }) {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const emailInputRef = useRef(null);

  useEffect(() => {
    // Auto-focus the email input when component mounts or when explicitly triggered
    const focusEmailInput = () => {
      if (emailInputRef.current) {
        emailInputRef.current.focus();
      }
    };

    // Focus on mount if already at beta-access section
    if (window.location.hash === '#beta-access') {
      setTimeout(focusEmailInput, 100);
    }

    // Listen for custom focus event (triggered by navigation to beta-access)
    const handleFocusBetaAccess = () => {
      setTimeout(focusEmailInput, 100);
    };

    // Handle hash changes for direct navigation
    const handleHashChange = () => {
      if (window.location.hash === '#beta-access') {
        setTimeout(focusEmailInput, 100);
      }
    };

    window.addEventListener('focusBetaAccess', handleFocusBetaAccess);
    window.addEventListener('hashchange', handleHashChange);

    return () => {
      window.removeEventListener('focusBetaAccess', handleFocusBetaAccess);
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    try {
      // Create signup (API handles duplicate checking)
      const response = await emailSignupService.create(email, false); // false = not waitlist only, just regular signup

      setMessage('Thanks for joining our waitlist! We\'ll notify you when Tournimate launches.');

      setEmail('');
    } catch (error) {
      console.error('Email signup error:', error);
      setMessage('Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 mb-4 text-center">
        Join the Waitlist
      </h2>
      <p className="text-gray-600 mb-6 text-center">
        Get notified when Tournimate launches and be among the first to try the intelligent scoresheet scanner.
      </p>
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
            Email Address
          </label>
          <input
            ref={emailInputRef}
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="your@email.com"
          />
        </div>
        
        <button
          type="submit"
          disabled={isLoading}
          className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {isLoading 
            ? 'Signing up...' 
            : 'Join Waitlist'}
        </button>
      </form>
      
      {message && (
        <div className={`mt-4 p-3 rounded-md ${
          message.includes('Thanks') ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
        }`}>
          {message}
        </div>
      )}
    </div>
  );
}

export default EmailSignup;